import { render, staticRenderFns } from "./AddInventoryItem.component.vue?vue&type=template&id=670e82c4&scoped=true&"
import script from "./AddInventoryItem.component.vue?vue&type=script&lang=js&"
export * from "./AddInventoryItem.component.vue?vue&type=script&lang=js&"
import style0 from "./AddInventoryItem.component.vue?vue&type=style&index=0&id=670e82c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e82c4",
  null
  
)

export default component.exports